import React from 'react';
import { motion } from 'framer-motion';
import { Typewriter } from 'react-simple-typewriter';

export default function Home() {
  const containerVariants = {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.3, delayChildren: 0.3 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { type: 'spring', stiffness: 100 } },
  };

  return (
    <section
      id="home"
      className="min-h-screen relative flex flex-col md:flex-row items-center justify-center px-6 md:px-20 py-16 bg-gradient-to-tr from-indigo-100 via-purple-100 to-pink-100 overflow-hidden"
    >
      {/* Floating Circles */}
      <motion.div
        className="absolute w-60 h-60 bg-pink-400 rounded-full mix-blend-multiply filter blur-3xl opacity-50"
        animate={{ y: [0, -30, 0], x: [0, 20, 0] }}
        transition={{ duration: 8, repeat: Infinity, ease: 'easeInOut' }}
        style={{ top: '10%', left: '5%' }}
      />
      <motion.div
        className="absolute w-72 h-72 bg-indigo-400 rounded-full mix-blend-multiply filter blur-2xl opacity-40"
        animate={{ y: [0, 30, 0], x: [0, -20, 0] }}
        transition={{ duration: 10, repeat: Infinity, ease: 'easeInOut' }}
        style={{ bottom: '15%', right: '10%' }}
      />
      <motion.div
        className="absolute w-48 h-48 bg-purple-400 rounded-full mix-blend-multiply filter blur-xl opacity-60"
        animate={{ y: [0, -15, 0], x: [0, 15, 0] }}
        transition={{ duration: 12, repeat: Infinity, ease: 'easeInOut' }}
        style={{ top: '50%', right: '20%' }}
      />

      {/* Profile Image */}
      <motion.div
        className="w-64 h-64 rounded-full overflow-hidden shadow-2xl border-4 border-white z-10 cursor-pointer"
        initial={{ opacity: 0, scale: 0.8, rotateY: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1, ease: 'easeOut' }}
        whileHover={{ rotateY: 15, scale: 1.05, transition: { type: 'spring', stiffness: 300 } }}
        whileTap={{ rotateY: 0, scale: 0.95 }}
      >
        <img
          src="/profile.png" // Replace with your actual image
          alt="Bereket"
          className="w-full h-full object-cover"
        />
      </motion.div>

      {/* Text and Buttons */}
      <motion.div
        className="max-w-xl mt-12 md:mt-0 md:ml-16 text-center md:text-left z-10"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.h1
          className="text-6xl font-extrabold text-indigo-900 mb-4 drop-shadow-xl"
          variants={itemVariants}
        >
          Hi, I'm Bereket Assefa
        </motion.h1>

        <motion.p
          className="text-2xl text-indigo-700 mb-8 min-h-[3rem]"
          variants={itemVariants}
        >
          <Typewriter
            words={[
              'Computer Science Graduate',
              'Frontend Web Developer',
              'Graphic Designer',
              'YouTube Thumbnail Designer on Upwork',
            ]}
            loop={0}
            cursor
            cursorStyle="|"
            typeSpeed={70}
            deleteSpeed={50}
            delaySpeed={2000}
          />
        </motion.p>

        {/* Buttons: See My Work & View CV */}
        <motion.div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start" variants={itemVariants}>
          <motion.a
            href="#portfolio"
            className="inline-block bg-indigo-600 text-white font-semibold py-4 px-12 rounded-full shadow-xl hover:bg-indigo-700 transition focus:outline-none focus:ring-4 focus:ring-indigo-300"
            whileHover={{ scale: 1.1, boxShadow: '0 0 15px rgba(79, 70, 229, 0.7)' }}
            whileTap={{ scale: 0.95 }}
          >
            See My Work
          </motion.a>
          <motion.a
            href="#cv"
            className="inline-block bg-purple-600 text-white font-semibold py-4 px-12 rounded-full shadow-xl hover:bg-purple-700 transition focus:outline-none focus:ring-4 focus:ring-purple-300"
            whileHover={{ scale: 1.1, boxShadow: '0 0 15px rgba(126, 34, 206, 0.7)' }}
            whileTap={{ scale: 0.95 }}
          >
            View CV & Certificates
          </motion.a>
        </motion.div>
      </motion.div>

      {/* Shimmer overlay */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-30 animate-shimmer"></div>
    </section>
  );
}
